import { type FieldValues, useController } from 'react-hook-form';

import type { ComponentProps } from '~/chords/ComponentProps';
import { FormField, type FormFieldProps } from '~/chords/FormField';
import { RadioGroup, type RadioGroupProps } from '~/components/RadioGroup';

type FormFieldRadioGroupProps<TFormFields extends FieldValues> = ComponentProps<
  Omit<FormFieldProps<TFormFields>, 'children'> &
    Omit<RadioGroupProps, 'name' | 'className'>
>;

export function FormFieldRadioGroup<TFormFields extends FieldValues>({
  name,
  label,
  dangerouslyOverrideClassName,
  disabled,
  readOnly,
  ...radioGroupProps
}: FormFieldRadioGroupProps<TFormFields>) {
  const { field } = useController({ name, disabled });

  return (
    <FormField
      name={name}
      label={label}
      dangerouslyOverrideClassName={dangerouslyOverrideClassName}
      disabled={disabled}
      readOnly={readOnly}
      labelAsSpan
    >
      <RadioGroup
        {...field}
        {...radioGroupProps}
        disabled={disabled}
        readOnly={readOnly}
        onChange={(value) => {
          field.onChange(value);
          radioGroupProps.onChange?.(value);
        }}
      />
    </FormField>
  );
}

FormFieldRadioGroup.displayName = 'FormFieldRadioGroup';
